import {useAppSelector} from 'hooks';

import {AppMode} from '../constants';

interface IAppMode {
  appMode: AppMode;
  isExpress: boolean;
  isRegular: boolean;
  isStorePickup: boolean;
}

export const useAppMode = (): IAppMode => {
  const appMode = useAppSelector((state) => state.app.appMode);

  const isExpress = appMode === AppMode.express;
  const isRegular = appMode === AppMode.regular;
  const isStorePickup = appMode === AppMode.storePickup;

  return {
    appMode,
    isExpress,
    isRegular,
    isStorePickup
  };
};
